module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-02.8eb089b6.png";